import { filteredCruisePackagesSelector } from './filterSelectors';
import { sortedCruiseListSelector } from './sortSelectors';

// Field-level selectors for the converted cruise-list view. Converted views select fields rather
// than the whole state tree, so a change to one slice re-renders only what reads it.
//
// The memoized selectors in ./filterSelectors and ./sortSelectors needed no change at this step:
// every `mapStateToProps` already handed them `state.toJS()`, so they were written against plain
// access all along — the same property step 2 predicted for flight-list and step 6 found in
// package-plus-list. What changed is that they now actually memoize, because `filterGroups` is a
// stable reference instead of a fresh object per `toJS()` call.
export const selectCommon = (state) => state.common;
export const selectSiteSettings = (state) => state.common.siteSettings;
export const selectUserId = (state) => state.common.userId;
export const selectIsInspiration = (state) => state.common.siteSettings.isInspiration;
export const selectCruises = (state) => state.cruises.cruises;
export const selectIsInitialized = (state) => state.cruises.initialized;
export const selectSearchInformation = (state) => state.cruises.searchInformation;
export const selectFilterGroups = (state) => state.filter.filterGroups;
export const selectFilterPanelIsVisible = (state) => state.filter.filterPanelIsVisible;
export const selectLabels = (state) => state.labels;
export const selectMessage = (state) => state.message;
export const selectSelectedSortOrder = (state) => state.sort.selected;
export const selectSortOptions = (state) => state.sort.sortOptions;
export const selectSortPanelIsVisible = (state) => state.sort.sortPanelIsVisible;

// Throws when `cruises` is null, exactly as the two components that read it did before.
export const selectNumberOfCruises = (state) => state.cruises.cruises.length;

// **The inspiration branch, expressed once.** `CruiseListContainer` and `CruiseCardList` each
// carried this identical conditional, reading `isInspiration` off `siteSettings` to decide whether
// the list is sorted at all. Both now read it from here. Returns whichever memoized selector
// applies, so the reference stays stable for `useSelector`.
export const selectVisibleCruises = (state) =>
  state.common.siteSettings.isInspiration ? filteredCruisePackagesSelector(state) : sortedCruiseListSelector(state);
